import CalendarSubscription from './CalendarSubscription';

export default CalendarSubscription;

